import { useState } from 'react';
import axios from 'axios';
import BASE_API_URL from '../apis/index';

const VerifyOtpForm = () => {
  const [form, setForm] = useState({ email: '', otp_code: '', type: 'email' });
  const [message, setMessage] = useState('');

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await axios.post(`${BASE_API_URL}/api/auth/verify-otp`, form);
      setMessage(res.data.message);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Verification failed');
    }
  };

  return (
    <div>
      <h2>Verify OTP</h2>
      {message && <p>{message}</p>}
      <form onSubmit={handleSubmit}>
        <input name="email" placeholder="Email" onChange={handleChange} required />
        <input name="otp_code" placeholder="OTP Code" onChange={handleChange} required />
        <select name="type" onChange={handleChange}>
          <option value="email">Email</option>
          <option value="mobile">Mobile</option>
        </select>
        <button type="submit">Verify</button>
      </form>
    </div>
  );
};

export default VerifyOtpForm;
